import { render, staticRenderFns } from "./find-specialization.vue?vue&type=template&id=6372b06d&"
import script from "./find-specialization.vue?vue&type=script&lang=js&"
export * from "./find-specialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports